<div class="backdrop" (click)="close()"></div>
<div class="side-panel" [class.open]="isOpen()">
  <ng-template cdkPortalOutlet></ng-template>
</div>
